export const sylwiaTrafna = {
    'mydrId': 'sylwiatrafna-jurkiewicz',
    'firstName': 'Sylwia',
    'lastName': 'Trafna-Jurkiewicz',
    'profession': 'Psychoterapeuta systemowy indywidualny i rodzin w trakcie certyfikacji',
    'avatar': 'sylwia-trafna-jurkiewicz.webp',
    'slug': 'terapeuta-rodzinny-sylwia-trafna-jurkiewicz',
    'locations': ['torun'],
    'services': [
        // ['group', 'preventionGroup'],
        // ['group', 'parentGroup'],
        ['psychoterapy', 'parents'],
        ['psychoterapy', 'system'],
        ['psychoterapy', 'family'],
        ['psychology', 'crisisIntervention'],
    ]
}